import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=d0f79d50&"
import script from "./permission.vue?vue&type=script&lang=ts&"
export * from "./permission.vue?vue&type=script&lang=ts&"
import style0 from "./permission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports